// shared-components/context/WebsiteContextDefinition.ts
import { createContext } from "react";
import type { WebsiteContextValue } from "../types/WebsiteTypes";

// Create the context
export const WebsiteContext = createContext<WebsiteContextValue | null>(null);
